
"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    // Always land on /home — handles both logged-in and logged-out states.
    // Logged-out visitors see the public landing view; logged-in users see their feed.
    router.replace('/home');
  }, [router]);

  return null;
}
